import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';

export default ({ app: { $dayjs } }) => {
    $dayjs.extend(duration);
    $dayjs.extend(relativeTime);
};
